<template>
  <div class="timeline">
    <div class="timeline__fixed">
      <select
        class="timeline__select"
        aria-label="Шаг"
        v-bind:value="''"
        v-on:input="onInput"
      >
        <option disabled value="">Шаг</option>
        <option
          v-for="option in $options.timeStepList"
          v-bind:key="option.value"
          v-bind:value="option.value"
          v-bind:class="{ selected: value === option.value }"
        >{{ option.label }}</option>
      </select>
    </div>
    <div class="timeline__step" />
    <div class="timeline__time">
      <time
        class="timeline__time__unit"
        v-for="time in timeline"
        v-bind:class="time.tags"
        v-bind:datetime="time.datetime"
        v-bind:key="time.datetime"
        v-bind:style="rulerUnitCSS">{{ time.title }}</time>
    </div>
  </div>
</template>

<script>

import mobileMixin from '@/mixins/mobileMixin';

/**
 * @description Название события ввода.
 * @type {string}
 */
const NAME_EVENT_INPUT = 'input';

/**
 * @description Название события ввода.
 * @type {string}
 */
const NAME_EVENT_PRINT_PAGE = 'print-page';

/**
 * @description Название события ввода.
 * @type {string}
 */
const NAME_EVENT_EXPORT_TO_EXCEL = 'export-to-excel';

/**
 * @description Список временных шагов.
 * @type {object[]}
 */
const timeStepList = [
  { value: 120, label: '2 ч' },
  { value: 90, label: '1,5 ч' },
  { value: 60, label: '1 ч' },
  { value: 45, label: '45 мин' },
  { value: 30, label: '30 мин' },
  { value: 15, label: '15 мин' },
];

export default {
  timeStepList,
  methods: {
    /**
     * @description Обработать ввод.
     * @param {InputEvent} event
     */
    onInput(event) {
      const { value } = event.target;
      this.$emit(NAME_EVENT_INPUT, value);
    },
    /**
     * @description Отправить событие печати страницы.
     * @returns {void}
     */
    dispatchPrintPage() {
      this.$emit(NAME_EVENT_PRINT_PAGE);
    },
    /**
     * @description Отправить событие выгрузки в excel.
     * @returns {void}
     */
    dispatchExportToExcel() {
      this.$emit(NAME_EVENT_EXPORT_TO_EXCEL);
    },
  },
  props: {
    /**
     * @description Стили CSS.
     * @type {any}
     */
    rulerUnitCSS: { required: true, type: Object },
    /**
     * @description Временная шкала.
     * @type {any[]}
     */
    timeline: { required: true, type: Array },
    /**
     * @description Шаг.
     * @type {number}
     */
    value: { required: true, type: Number },
    /**
     * @description Деактивировать кнопку экспорта.
     * @type {boolean}
     */
    isDisableExport: { type: Boolean, default: true },
  },
  mixins: [
    mobileMixin,
  ],
};
</script>

<style scoped lang="scss">
.timeline {
  position: sticky;
  left: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  border: 1px solid rgba(194, 207, 224, 0.5);
  border-top: none;
  width: 54px;
  min-width: 54px;
  background: #ffffff;
  z-index: 3;
  &__fixed {
    position: sticky;
    position: -webkit-sticky;
    z-index: 2;
    top: 0;
    background: #ffffff;
    width: 54px;
    height: 61px;
    border-left: 1px solid rgba(194, 207, 224, 0.5);
    border-right: 1px solid rgba(194, 207, 224, 0.5);
    &__row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 5px;
      border-bottom: 1px solid rgba(194, 207, 224, 0.5);
    }
  }
  &__print {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 6px 0;
    border-right: 1px solid rgba(194, 207, 224, 0.5);
    &:before {
      content: "";
      background-image: url("@/assets/img/print-grey.svg");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      width: 18px;
      height: 18px;
    }
    &:hover::before {
      background-image: url("@/assets/img/print.svg");
    }
  }
  &__export {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 6px 0;
    &:before {
      content: "";
      background-image: url("@/assets/img/excel.svg");
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      width: 18px;
      height: 18px;
    }
    &:hover::before {
      background-image: url("@/assets/img/excel-blue.svg");
    }
  }
  &__select {
    background-color: transparent;
    background-image: url("@/assets/img/checked/checked-triangle.svg");
    background-position: center bottom 16px;
    border: 1px solid transparent;
    border-bottom: 1px solid rgba(194, 207, 224, 0.5);
    outline: none;
    width: 100%;
    height: 100%;
    appearance: none;
    font-size: 12px;
    color: #707683;
    text-align: center;
    text-align-last: center;
    font-weight: 400;
    cursor: pointer;
    margin: 0 auto;
    option {
      text-align: center;
      &.selected {
        color: #ffffff;
        background-color: #0489e0;
      }
    }
    &:hover {
      color: #0489e0;
    }
    &:focus {
      color: #192a3e;
      background-color: transparent;
      border: 1px solid transparent;
      outline: 0;
      background-image: url("@/assets/img/checked/checked-triangle-top.svg");
    }
  }
  &__time {
    display: flex;
    flex-direction: column;
    padding: 0;
    width: 100%;
    &__unit {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #707683;
      font-weight: 400;
      font-size: 12px;
      border-top: 1px solid rgba(194, 207, 224, 0.5);
      border-bottom: 1px solid rgba(194, 207, 224, 0.5);
    }
    &__unit.now {
      background-color: #357ebd;
      color: var(--primary-background-color);
      margin: 0 -1px;
    }
  }
}
@media screen and (max-width: 480px) {
  .timeline {
    height: fit-content;
    border-bottom: none;
    &__select {
      height: 61px;
    }
    &__fixed {
      &__row {
        display: none;
      }
    }
    &__print, &__export {
      display: none;
    }
    &__collapse {
      display: flex;
    }
  }
}
</style>
